<div class="code-popup">
    <h2 class="text-center">Enter 2FA Code</h2>
    <input class="code-input" [(ngModel)]="code"/> 
    <div class="d-flex">
         <button class="code-button btn" (click)="verifyCode()">Verify</button>
        <button class="code-button-cancel btn" (click)="cancel()">Cancel</button>
    </div>
</div>